/* unplugin-vue-components disabled */import { render } from "./AreaInfo.vue?vue&type=template&id=a0665f20&ts=true"
import script from "./AreaInfo.vue?vue&type=script&lang=ts"
export * from "./AreaInfo.vue?vue&type=script&lang=ts"

import "./AreaInfo.vue?vue&type=style&index=0&id=a0665f20&lang=scss"

import exportComponent from "/root/workspace/estate-mobile_TiQu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__